module.exports = __webpack_public_path__ + "img/lock-icon.d2f3d612.svg";